import {reqJson} from './axiosFun';

/**
 * 消息通知信息管理
 **/
//查询我的消息数量（未读）
export const myMsgCount = () => {
  return reqJson("get", "/api/commonmsg/msgCount")
};
//消息通知分页查询
export const queryByPageByAdmin = (params) => {
  return reqJson("post", "/api/commonmsg/queryByPageByAdmin", params)
};
//阅读
export const read = (id) => {
  return reqJson("get", "/api/commonmsg/read?id=" + id)
};




// WEBPACK FOOTER //
// ./src/api/commonMsgMG.js